import { auth } from '@/lib/firebase';
import { getAuthToken } from '@/lib/api-client';

/**
 * Token for the WebSocket `authenticate` handshake, called on every (re)connect.
 *
 * Prefers the Firebase SDK, which returns its cached ID token and refreshes it
 * transparently near expiry. The storage copy is only refreshed after a REST
 * 401, so on a page with no REST traffic it goes stale after an hour — and
 * Cloud Run drops the socket every few minutes, so the next reconnect gets
 * rejected by the backend with `auth/id-token-expired` (DEV2-1519).
 */
export async function getSocketAuthToken(): Promise<string | null> {
  if (auth.currentUser) {
    try {
      return await auth.currentUser.getIdToken();
    } catch {
      // Offline or refresh failed — fall through to the stored copy. If the
      // backend rejects it, the socket manager retries with backoff.
    }
  }

  return getAuthToken();
}
